import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import GlobalVariablesProvider from "./GlobalVariables";
import CallProvider from "./CallContext";
import IncomingCallModal from "./modals/IncomingCallModal";
import ActiveCallIndicator from "./modals/ActiveCallIndicator";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <GlobalVariablesProvider>
      <CallProvider>
        <div>
          <Toaster position="bottom-right"></Toaster>
        </div>
        <IncomingCallModal />
        <ActiveCallIndicator />
        <App />
      </CallProvider>
    </GlobalVariablesProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

